import { useTranslation } from 'react-i18next'
import { Box, Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    root: {
        background: '#FFFFFF',
        border: (theme) => `1px dashed ${theme.palette.secondary.main}`,
        borderRadius: 2,
        cursor: 'pointer',
        minWidth: '300px',
        maxWidth: '460px',
        flex: 1,
    },
}

const AddItemCard = ({ buttonText, helperText = null, icon = null, onButtonClick, title }) => {
    const { t } = useTranslation()

    return (
        <Box
            sx={[
                {
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-around',
                    padding: 3,
                    gap: 1.5,
                },
                classes.root,
            ]}
        >
            {icon ? <Box>{icon}</Box> : null}
            <Box
                sx={[
                    {
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1.5,
                    },
                    classes.dropTextContainer,
                ]}
            >
                {title ? (
                    <Typography
                        align="center"
                        variant="body1"
                    >
                        {t(title)}
                    </Typography>
                ) : null}

                <Button
                    color="primary"
                    size="medium"
                    variant="contained"
                    onClick={onButtonClick}
                >
                    {t(buttonText)}
                </Button>
                {helperText ? (
                    <Typography
                        align="center"
                        variant="small"
                    >
                        {t(helperText)}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    )
}

AddItemCard.propTypes = {
    buttonText: PropTypes.string,
    helperText: PropTypes.string,
    icon: PropTypes.element,
    title: PropTypes.string,
    onButtonClick: PropTypes.func,
}

export default AddItemCard
